import { IFormField} from "../web-form.objects"
import { JsonItem, PickListItem } from "../../../entities/pick-list/pick-list.entities";
import _ from "lodash";

export class YesNoInputOptions {
    constructor() {

    }
}

export class YesNoInputField implements IFormField {
    fieldId: string;
    displayName: string;
    description: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;
    initialVal: any;

    options: YesNoInputOptions;

    constructor(propertyName: string, fieldId: string, displayName: string, description: string, isRequired: boolean, options: YesNoInputOptions = new YesNoInputOptions()) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.description = description;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.options = options;

        this.defaultVal = undefined;
        this.initialVal = undefined;
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";

        let html = `
            <label for="" class="${requiredClass}">${this.displayName}</label>
            ${this.description != "" ? `<p class='form-text'>${this.description}</p>` : ``}
            <select id="${this.fieldId}" class="selectpicker dropdown ciig-form-dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5"></select>
        `

        return html;
    }

    initialize() {
        this.generateDropdown();

        $(`#${this.fieldId}`).on("changed.bs.select", () => {
            $(`#${this.fieldId}`).trigger("form-field-change");
        });
    }

    setOptions(pickLists: JsonItem[]) {
        return;
    }

    prepopulate(items: any[]): void {
        this.initialVal = undefined;

        // Check if all are the same
        if (items.every((item, i, arr) => _.get(item, this.propertyName) == _.get(arr[0], this.propertyName)) && items.length > 0) {
            this.initialVal = _.get(items[0], this.propertyName);
        }

        this.setInput(this.initialVal);
    }

    updateItem(item: any): any {
        let updatedItem = _.cloneDeep(item);
        _.set(updatedItem, this.propertyName, this.getValue());
        return updatedItem;
    }

    private generateDropdown() {
        $(`#${this.fieldId}`).find("option").remove();
        $(`#${this.fieldId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        // Add default option with no value to show no input (no favoritism)
        $(`#${this.fieldId}`).append(`<option hidden disabled selected value>-- Select --</option>`);
        let options: PickListItem[] = [
            { Id: 0, Value: "No" },
            { Id: 1, Value: "Yes" },
        ]

        options.forEach(option => {
            $(`#${this.fieldId}`).append(new Option(option.Value, option.Id.toString(), false, false));
        })

        $(`#${this.fieldId}`).selectpicker("refresh");
    }

    private getInput(): string {
        let input = <string>$(`#${this.fieldId}`).val();
        let returnVal = "Not Specified";
        if (input == "1") {
            returnVal = "Yes";
        }
        else if (input == "0") {
            returnVal = "No"
        }
        return returnVal;
    }

    private setInput(data: boolean) {
        let strVal = "";
        if (data === false) {
            strVal = "0";
        }
        else if (data === true) {
            strVal = "1"
        }
        $(`#${this.fieldId}`).selectpicker("val", strVal);
    }

    private getParsedInput(): boolean {
        let input = this.getInput();

        if (input == "Yes") {
            return true;
        }
        else if (input == "No") {
            return false;
        }

        return undefined;
    }

    getValue(): any {
        let val = this.initialVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getParsedInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        this.setInput(formVal);
    }

    checkValid(): boolean {
        let inputStr = this.getInput();
        // empty
        if (inputStr == "Not Specified") {
            return false;
        }

        return true;
    }

    checkChanged(): boolean {
        let val = this.getParsedInput();
        if (val != this.initialVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).siblings(".dropdown-toggle").addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
    }

    private getDisplayVal(item: any): string {
        let val = _.get(item, this.propertyName);

        if (val == true) {
            return "Yes"
        }
        else if (val == false) {
            return "No"
        }
        else {
            return "Not Specified";
        }
    }

    compareItems(item1: any, item2: any): boolean {
        let x1 = <boolean>_.get(item1, this.propertyName);
        let x2 = <boolean>_.get(item2, this.propertyName);

        return x1 === x2;
    }

    generateChangeHtml(newItem: any, prevItem: any): string {
        let isChanged = false;

        if (prevItem == undefined) {
            isChanged = true;
        }
        else {
            isChanged = !this.compareItems(newItem, prevItem);
        }

        if (!isChanged) {
            return "";
        }

        let changeContent = "";
        let newVal = _.get(newItem, this.propertyName);
        if (newVal != undefined) {
            let newDisplay = `
                    <div class="new-change-block change-block">
                        <div class="col-auto">
                            <i class="fa-solid fa-plus new-change-icon"></i>
                        </div>
                        <div class="col">
                            ${this.getDisplayVal(newItem)}
                        </div>
                    </div>
                `;
            changeContent = newDisplay;
        }

        if (prevItem != undefined) {
            let prevVal = _.get(prevItem, this.propertyName);
            if (prevVal != undefined) {
                let prevDisplay = `
                        <div class="delete-change-block change-block">
                            <div class="col-auto">
                                <i class="fa-solid fa-trash-can delete-change-icon"></i>
                            </div>
                            <div class="col">
                                ${this.getDisplayVal(prevItem)}
                            </div>
                        </div>
                    `;
                changeContent += prevDisplay;
            }
        }

        let html = `
                <div class="change-content-block">
                    <div class="change-content-label">
                        ${this.displayName}
                    </div>
                    ${changeContent}
                </div>
            `;

        return html;
    }
}

